// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const SelectActionsheetScrollView = createStyle({
  w: '$full',
  h: 'auto',
});
